import { render, staticRenderFns } from "./EventForm2.vue?vue&type=template&id=1f1c9f64&scoped=true"
import script from "./EventForm2.vue?vue&type=script&lang=js"
export * from "./EventForm2.vue?vue&type=script&lang=js"
import style0 from "./EventForm2.vue?vue&type=style&index=0&id=1f1c9f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c9f64",
  null
  
)

export default component.exports